export default __webpack_public_path__ + "static/media/LaptopStand_Blue_Desktop.c9cadf13.png";